// Module
var code = "<md-button class=\"back\"> <md-icon>keyboard_arrow_left</md-icon> <span hide-sm hide-xs ng-bind=\"back\"></span> <md-tooltip><span ng-bind=\"back\"></span></md-tooltip> </md-button> ";
// Exports
module.exports = code;